import { Formik, FormikHelpers } from 'formik'
import { ObjectSchema } from 'Yup'
import { Assign, ObjectShape } from 'yup/lib/object'


interface iValidatedFormProps{
    children: JSX.Element | JSX.Element[]
    initialValues: Record< string | number | symbol, any>
    onSubmit: (values: any, formikHelepers: FormikHelpers<any>)=>void | Promise<any>
    validationSchema: ObjectSchema<Assign<ObjectShape, any>>
}

export default function ValidatedForm({children, initialValues, onSubmit, validationSchema}: iValidatedFormProps) {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, formikHelpers)=>onSubmit(values, formikHelpers)}
        >

            <>
                {children}
            </>

        </Formik>
    )
}
